import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { resetPassword } from 'aws-amplify/auth';
import FlowRCMLogo from '../components/FlowRCMLogo';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [codeSent, setCodeSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setError('');
      setMessage('');
      setLoading(true);

      await resetPassword({ username: email });

      setCodeSent(true);
      setMessage('A verification code has been sent to your email. Please check your inbox and use the code on the next page to reset your password.');
    } catch (error) {
      const msg = error.message || '';
      if (msg.includes('UserNotFoundException') || msg.includes('user not found')) {
        setError('No account found with that email address.');
      } else if (msg.includes('LimitExceededException')) {
        setError('Too many attempts. Please wait a few minutes and try again.');
      } else {
        setError('Failed to send reset code. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-4">
          <div className="flex justify-center mb-4">
            <FlowRCMLogo variant="light" hideSubtitle={true} />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Reset Your Password</h1>
          <p className="text-slate-600 mt-2">Enter your email to receive a verification code</p>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 p-8" style={{boxShadow: '0 0 10px rgba(0,0,0,0.1)'}}>
          <form onSubmit={handleSubmit} className="space-y-6">
            {message && (
              <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
                {message}
              </div>
            )}

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            {!codeSent ? (
              <>
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-2">
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                    placeholder="you@dentalclinic.com"
                    disabled={loading}
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Sending...
                    </>
                  ) : (
                    'Send Verification Code'
                  )}
                </button>
              </>
            ) : (
              <div className="text-center">
                <Link
                  to={`/reset-password?email=${encodeURIComponent(email)}`}
                  className="inline-block w-full bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors text-center"
                >
                  Enter Verification Code
                </Link>
              </div>
            )}
          </form>

          <div className="mt-6 text-center">
            <Link to="/login" className="text-teal-600 hover:text-teal-700 font-semibold text-sm">
              &larr; Back to Login
            </Link>
          </div>
        </div>

        <div className="mt-4 text-center text-sm text-slate-500">
          <p>&copy; 2026 FlowRCM. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
